import React, {Component} from 'react'
import styled from '@emotion/styled'

const AddGoodReviewRoot = styled.div`
  margin-top: 10px;
`

const Textarea = styled.textarea`
  box-sizing: border-box;
  width: 100%;
  height: 100px;
  border: 1px solid #ddd;
  margin-bottom: 10px;
  padding: 10px;
  font: 13px/1.5 Merriweather, serif;
  font-style: italic;

  &:focus {
    outline: none;
    border-color: #95bb9e;
  }

`

const Submit = styled.input`
  border: none;
  border-radius: 0;
  padding: 10px 15px;
  line-height: 1.3;
  cursor: pointer;
  transition: background-color 0.2s;
  white-space: nowrap;
  background-color: #6fb971;
  color: white;
  font-family: Merriweather, serif;    
  font-size: 12px;
  font-weight: 400;

  &:hover {
    background-color: #4ec152;
  }
  
  &:focus {
    outline: none;
  }
`

const Done = styled.div`
  font-weight: 500;
`

const Error = styled.div`
  margin-top: 10px;
  color: #ec2323;
`

class AddGoodReviewLayout extends Component {
  state = {
    text: '',
  }

  addGoodReview = (text) => {
    this.props.addGoodReview({
      variables: {
        goodId: this.props.good.id,
        text
      },
    })
  }

  handleTextChange = (event) => {
    this.setState({
      text: event.target.value
    })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const text = this.state.text
    if (!text) return
    this.addGoodReview(text)
  }

  render() {
    return <AddGoodReviewRoot>
      {this.props.done && <Done>Спасибо! Отзыв будет добавлен после модерации.</Done>}
      {!this.props.done && <form onSubmit={this.handleSubmit}>
        <Textarea value={this.state.text} onChange={this.handleTextChange} placeholder="Отзыв"/>
        <Submit type="submit" value="Добавить отзыв"/>
      </form>}
      {this.props.error && <Error>Произошла ошибка. Пожалуйста, повторите попытку или попробуйте позже.</Error>}
    </AddGoodReviewRoot>
  }
}

export default AddGoodReviewLayout
